import * as React from 'react';
import {
  Card,
  HStack,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';

type Props = {
  label: string;
  note?: string;
  /** Marks a legacy/rarely-used token so the audit surfaces it, not just lists it. */
  flagged?: boolean;
  /** Recency marker — see ChangeBadge. */
  badge?: React.ReactNode;
  children: React.ReactNode;
};

/**
 * Single audit-grid cell: a demo area on top, label + optional note
 * underneath. Used across every section (colors, type, icons,
 * components) so the whole page reads as one consistent grid.
 */
export const Tile = ({ label, note, flagged, badge, children }: Props) => (
  <Card
    p={3}
    borderColor={flagged ? 'orange' : 'cloud'}
    borderWidth={flagged ? '2px' : '1px'}
  >
    <VStack gap={3} align="stretch">
      <VStack align="stretch" justifyContent="center" minH="48px">
        {children}
      </VStack>

      <VStack gap={0} align="stretch">
        <HStack gap={2} align="center">
          <Text fontSize="xs" fontWeight="semibold" color="muted.900">
            {label}
          </Text>
          {badge}
        </HStack>
        {note && (
          <Text fontSize="2xs" color="muted.400">
            {note}
          </Text>
        )}
      </VStack>
    </VStack>
  </Card>
);
